import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const H5 = styled.h5`
  font-weight: 600;
  &,
  * {
    font-size: 18px;
    line-height: 24px;
  }

  ${media.tablet`
    &, * {
      font-size: 16px;
      line-height: 24px;
    }
  `}
`

export default H5
